import React from 'react';
import styles from './PageHeader.module.css';

export interface PageHeaderProps {
  collapsed: boolean;
  welcomeLabel: string;
  onToggleSidebar: () => void;
  onGenerateReport?: () => void;
  onLogout: () => void;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  collapsed,
  welcomeLabel,
  onToggleSidebar,
  onGenerateReport,
  onLogout,
}) => {
  return (
    <header className={styles.pageHeader}>
      <div className={styles.pageTitleGroup}>
        <div>
          <h6 className={styles.pageEyebrow}>ADMIN WORKSPACE</h6>
        </div>
      </div>
      <div className={styles.headerActions}>
        {onGenerateReport && (
          <button className={`${styles.button} ${styles.buttonSky}`} onClick={onGenerateReport}>
            <span className={styles.buttonIcon} aria-hidden>
              <svg viewBox="0 0 24 24" width="16" height="16">
                <path
                  d="M12 5v14M5 12h14"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              </svg>
            </span>
            <span>Create report</span>
          </button>
        )}
        <button className={styles.logoutButton} onClick={onLogout}>
          <span className={styles.buttonIcon} aria-hidden>
            <svg viewBox="0 0 24 24" width="16" height="16">
              <path
                d="M9 5h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9"
                stroke="currentColor"
                strokeWidth="1.6"
                fill="none"
                strokeLinecap="round"
              />
              <path
                d="M11 12h9M15 8l5 4-5 4"
                stroke="currentColor"
                strokeWidth="1.6"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
};
